import { useRef, useEffect } from 'react';
import styles from './DropDownResults.module.css';
import { SelectedItem, MultiSelectDropDownOption } from './types';
import { SelectionType } from './constants';
import DropDownOption from './DropDownOption';

interface FlatOptionsProps {
  options: MultiSelectDropDownOption[];
  selectedItems: SelectedItem[];
  onItemSelect: (value: string, group?: string, type?: SelectionType, label?: string) => void;
  focusedIndex: number;
}

const FlatOptions = ({ options, selectedItems, onItemSelect, focusedIndex }: FlatOptionsProps) => {
  const focusedElementRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (focusedElementRef.current) {
      focusedElementRef.current.scrollIntoView({ block: 'nearest' });
    }
  }, [focusedIndex]);

  const getItemStatus = (id: string) => {
    return selectedItems.find((item) => item.value === id);
  };

  return (
    <div className={styles.optionsList}>
      {options.map((option, index) => {
        const status = getItemStatus(option.id);
        const isFocused = index === focusedIndex;
        return (
          <DropDownOption
            key={`${option.id}-${option.value}`}
            ref={isFocused ? focusedElementRef : null}
            option={option}
            status={status}
            isFocused={isFocused}
            onItemSelect={onItemSelect}
            optionIndex={index}
          />
        );
      })}
    </div>
  );
};

export default FlatOptions;
